import BasketEmptyBanner from "./BasketEmptyBanner";
import BasketPersonalizedSection from "./BasketPersonalizedSection";

const EmptyBasket = () => {
  return (
    <div className="container-main py-6">
      <BasketEmptyBanner />
      <BasketPersonalizedSection />
    </div>
  );
};

export default EmptyBasket;